export default __webpack_public_path__ + "static/media/icon-pencil-white.0a6f2ba4.svg";